import { StylingModel } from '../style/styling.model';
import { CoreStylingModel } from '../core/core-styling.model';
import { IconStylingModel } from '../icon/icon-styling.model';
import { ImageStylingModel } from '../image/image-styling.model';
export class AvatarStylingModel extends CoreStylingModel {
/**
 * ImageStylingModel for cf-image
 */
image?: ImageStylingModel;
/**
 * IconStylingModel for cf-icon
 */
icon?: IconStylingModel;
/**
 * StylingModel for name
 */
name?: StylingModel;
/**
 * StylingModel for text
 */
text?: StylingModel;
/**
 * @hidden
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
  }
}

function AvatarStylingModel_tsickle_Closure_declarations() {
/**
 * ImageStylingModel for cf-image
 * @type {?}
 */
AvatarStylingModel.prototype.image;
/**
 * IconStylingModel for cf-icon
 * @type {?}
 */
AvatarStylingModel.prototype.icon;
/**
 * StylingModel for name
 * @type {?}
 */
AvatarStylingModel.prototype.name;
/**
 * StylingModel for text
 * @type {?}
 */
AvatarStylingModel.prototype.text;
}

